/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { FormSelectField } from '../../../../../../../semantic-ui/components/form-select-field';
import { FormInputField } from '../../../../../../../semantic-ui/components/form-input-field';
import AddButton from '../../../../../../../components/images/add-button.svg';

export const DocumentsComponent = ({ fields, documentTypes, formValues, change }) => {
	if (fields.length === 0) {
		fields.push({});
	}

	const handleRemove = index => {
		if (fields.length > 1) {
			fields.remove(index);
		} else {
			change(`${fields.name}[0].key`, '');
			change(`${fields.name}[0].name`, '');
		}
	};

	return (
		<>
			<Grid.Row className="company-setting-document-component__row">
				<Grid.Column className="company-setting-document-component__text__small">
					Требовать документы по доставке груза
				</Grid.Column>
			</Grid.Row>
			{fields.map((el, index) => (
				<Grid.Row
					className="company-setting-document-component__row"
					key={el.id || `company-setting-document-${index}`}
				>
					<Grid.Column width={3} className="company-setting-document-component__column">
						Документ №{index + 1}
					</Grid.Column>
					<Grid.Column
						width={fields.get(index).key === '8-other' ? 4 : 8}
						className="company-setting-document-component__column"
					>
						<div className="company-setting-document-component__column-with-button">
							<Field
								name={`${el}.key`}
								type="text"
								component={FormSelectField}
								autoComplete="off"
								options={formValues.documentTypes || documentTypes}
								placeholder="Выберите документ"
								isWithoutSelectOnBlur
								search
								dropdownClassName="company-setting-document-component__dropdown"
								noResultsMessage="Документ не найден"
							/>
						</div>
					</Grid.Column>
					{fields.get(index).key === '8-other' && (
						<Grid.Column width={4} className="company-setting-document-component__column-name">
							<div
								className="company-setting-document-component__input_row"
								ref={ref => {
									if (ref) {
										ref.setAttribute('name', `${el}.name`);
									}
								}}
							>
								<Field
									name={`${el}.name`}
									component={FormInputField}
									placeholder="Название документа"
								/>
							</div>
						</Grid.Column>
					)}
					{index === fields.length - 1 && (
						<Grid.Column>
							<div
								className="company-setting-document-component__close"
								onClick={() => handleRemove(index)}
							/>
						</Grid.Column>
					)}
				</Grid.Row>
			))}
			<Grid.Row className="company-setting-document-component__row">
				<Grid.Column width={11} className="company-setting-document-component__column">
					<div className="company-setting-document-component__button-row">
						<div className="company-setting-document-component__button-row-text">Добавить документ</div>
						<img src={AddButton} alt="add-button" onClick={() => fields.push({})} />
					</div>
				</Grid.Column>
			</Grid.Row>
		</>
	);
};

DocumentsComponent.propTypes = {
	fields: PropTypes.object.isRequired,
	documentTypes: PropTypes.array.isRequired,
	change: PropTypes.func.isRequired,
	formValues: PropTypes.object,
};
